import type { ReactNode } from "react";

interface DetailHeroLayoutProps {
  media: ReactNode;
  content: ReactNode;
}

export function DetailHeroLayout({ media, content }: DetailHeroLayoutProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-16">
      {media}
      {content}
    </div>
  );
}
